
const backgroundColors = {
    1: 'black',
    2: 'pink',
    3: 'tan',
    4: 'brown',
    5: 'light',
    6: 'gray'
}
const getBackgroundColor = id => `background-${backgroundColors[id]}` || 'background-white';

export default getBackgroundColor;
